module.exports = __webpack_public_path__ + "5cf5c8bb2fd220651a132aaaedaded58.svg";